import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { Permission } from '../models/permission.model';

@Injectable({
  providedIn: 'root',
})
export class IAMService {
  private permissions: Permission[] = [];
  private isLoaded: boolean = false;

  constructor(private http: HttpClient) {}

  public hasPermission(claimName: string, claimValue?: string): Observable<boolean> {
    if (this.isLoaded) {
      return of(this.permissions).pipe(map((permissions) => this.checkPermission(permissions, claimName, claimValue)));
    }

    return this.getPermissions().pipe(
      tap((permissions: Permission[]) => {
        this.permissions = permissions;
        this.isLoaded = true;
      }),
      map((permissions) => this.checkPermission(permissions, claimName, claimValue))
    );
  }

  private getPermissions() {
    const url = `${environment.calculationApi}/v1/permissions`;
    return this.http.get<Permission[]>(url);
  }

  private checkPermission(permissions: Permission[], claimName: string, claimValue?: string) {
    const claims = permissions.filter((perm) => perm.name === claimName);

    let hasPermission = false;

    claims.forEach((claim) => {
      if (claimValue === undefined || claim.value === claimValue) {
        hasPermission = true;
        return;
      }
    });

    return hasPermission;
  }
}
